import { render, staticRenderFns } from "./account-dropdown.vue?vue&type=template&id=39ee3e9d&scoped=true&"
import script from "./account-dropdown.vue?vue&type=script&lang=ts&"
export * from "./account-dropdown.vue?vue&type=script&lang=ts&"
import style0 from "./account-dropdown.vue?vue&type=style&index=0&id=39ee3e9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ee3e9d",
  null
  
)

export default component.exports